// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let AgentInfo = require("./AgentInfo.bs.js");
let AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let TerminatedAgentIconOverlay = require("./TerminatedAgentIconOverlay.bs.js");

function AnonymousAgentInfo(props) {
  let __isTerminated = props.isTerminated;
  let __size = props.size;
  let size = __size !== undefined ? __size : "xSmall";
  let isTerminated = __isTerminated !== undefined ? __isTerminated : false;
  let content = JsxRuntime.jsx(AgentInfo.Presentation.make, {
    avatar: AvatarSrcUrl.place_holder,
    size: size,
    name: "The agent chose to hide their name",
    brokerage: isTerminated ? "NO LONGER ON TAN" : undefined,
    wrapName: name => JsxRuntime.jsx("div", {
      children: name,
      className: size === "xxSmall" ? "font-normal" : "font-medium"
    })
  });
  if (isTerminated) {
    return JsxRuntime.jsx(TerminatedAgentIconOverlay.make, {
      size: size,
      children: content
    });
  } else {
    return content;
  }
}

let make = AnonymousAgentInfo;

exports.make = make;
/* AgentInfo Not a pure module */
